import React from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AdminProvider } from "@/context/AdminContext";
import { MediaViewerProvider, ScrollManager } from "@/components/shared";
import AppRoutes from "@/routes";
import "@/App.css";

function App() {
  return (
    <HelmetProvider>
      <AdminProvider>
        <MediaViewerProvider>
          <BrowserRouter>
            <ScrollManager />
            <AppRoutes />
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </MediaViewerProvider>
      </AdminProvider>
    </HelmetProvider>
  );
}

export default App;
